module.exports = __webpack_public_path__ + "static/media/0017.3f22b5d9.png";